var map = {
	"./account.png": "3b2e",
	"./bigBag.png": "8951",
	"./close.png": "04b3",
	"./def_img.jpg": "3adc",
	"./gift-history.png": "2360",
	"./homeBg.jpg": "66f1",
	"./icons/account/email.png": "f64e",
	"./icons/account/sms.png": "311d",
	"./icons/arrow_red.png": "c8e7",
	"./icons/card/addMore.png": "b141",
	"./icons/card/edit.png": "43a6",
	"./icons/card/from.png": "7060",
	"./icons/card/time.png": "041b",
	"./icons/cardIcon.png": "3628",
	"./icons/cart.png": "ee4d",
	"./icons/checkout/pickup_logo.svg": "4f58",
	"./icons/checkout/pickup_logo_cart.svg": "66f3",
	"./icons/checkout/time.svg": "de6e",
	"./icons/close_red.png": "0414",
	"./icons/giftcards/giftDef.png": "1e24",
	"./icons/home/bagel.png": "0d81",
	"./icons/home/bublicdesk.png": "3e8c",
	"./icons/home/bublikw.png": "d05f",
	"./icons/location/bascket.png": "a6b4",
	"./icons/location/current_location.png": "a5dc",
	"./icons/location/info.png": "241ef",
	"./icons/location/list.png": "c586",
	"./icons/menu/check.png": "acc3",
	"./icons/menu/check_checked.png": "cd27",
	"./icons/menu/closeIcon.png": "ea52",
	"./icons/menu/demoicon_selected.png": "af8a",
	"./icons/menu/menuBanner.jpg": "c843",
	"./icons/menu/menu_inactive.png": "13d8",
	"./icons/menu/menu_selected.png": "3af1",
	"./icons/menu/openMenu.png": "cd69",
	"./icons/nav/[Originals]/order-history-icon-9.png": "0805",
	"./icons/nav/demoicon_selected.png": "3c14",
	"./icons/nav/egifts.png": "50ad",
	"./icons/nav/gift-history.png": "0769",
	"./icons/nav/home.png": "1db3",
	"./icons/nav/location.png": "19db",
	"./icons/nav/order-history.png": "4155",
	"./icons/nav/order.png": "91c7",
	"./icons/nav/rewards.png": "e986",
	"./icons/nav/transaction.png": "2565",
	"./icons/payment/apple_pay.png": "3739",
	"./icons/payment/apple_pay.svg": "0d23",
	"./icons/payment/google_pay.png": "f498",
	"./icons/payment/google_pay.svg": "75f6",
	"./icons/selectIc.png": "f553",
	"./icons/social/facebook.png": "d69ae",
	"./icons/social/instagram.png": "dcfc",
	"./icons/social/twitter.png": "0e6e",
	"./icons/top_bar/back_button.png": "6131",
	"./icons/top_bar/close.png": "fc46",
	"./icons/top_bar/login.png": "fc85",
	"./icons/top_bar/search.png": "4b35",
	"./icons/top_bar/search_small.png": "8b8e",
	"./landingpage-min.jpg": "db32",
	"./landingpage.jpg": "84ac",
	"./location.png": "9076",
	"./logo.png": "4ffd",
	"./pageLoader.gif": "8721",
	"./pickup_logo_cart.svg": "2cb5",
	"./rewards.png": "2bf4",
	"./temp.jpg": "53ab",
	"./transaction.png": "e730"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";